var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "div",
            { staticStyle: { "margin-top": "5px" } },
            [
              _vm.isEdit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "Cancel" },
                      on: { click: _vm.cancel }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                  )
                : _vm._e(),
              _vm.isEdit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "Save" },
                      on: { click: _vm.save }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                  )
                : _vm._e(),
              !_vm.isEdit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "Back" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("back")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Back")))]
                  )
                : _vm._e(),
              !_vm.isEdit && _vm.editShow && _vm.source === "CarFormTab"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "Edit" },
                      on: { click: _vm.edit }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-form",
            {
              staticClass: "car-form-detail-form",
              staticStyle: {
                "margin-top": "5px",
                "background-color": "#f0f3f8",
                padding: "5px"
              },
              attrs: {
                disabled: !_vm.isEdit,
                "label-width": _vm.$selectByLang("100px", "140px"),
                "label-position": "left"
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_VehicleOrderNo")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.carFormNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "carFormNo", $$v)
                              },
                              expression: "form.carFormNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_Motorcade") }
                        },
                        [
                          _c("cargo-company-select", {
                            attrs: {
                              no: "carryingCmp",
                              clearable: "",
                              filterable: "",
                              "method-params": { truckCmp: true, active: true },
                              "default-value": _vm.form.carryingCmp || 0
                            },
                            on: {
                              change: function(p) {
                                _vm.form.carryingCmp = p.value || 0
                                _vm.carryingCmpChangeHandler()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Warehouse.Driver") } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: !_vm.isEdit
                                  ? ""
                                  : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                                "allow-create": true,
                                clearable: true,
                                filterable: ""
                              },
                              on: { change: _vm.driverNameChangeHandler },
                              model: {
                                value: _vm.form.driverName,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "driverName", $$v)
                                },
                                expression: "form.driverName"
                              }
                            },
                            _vm._l(_vm.driverInfomations, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.driverName,
                                  value: item.driverName
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.TruckNo") } },
                        [
                          _c("el-input", {
                            on: {
                              input: function(val) {
                                _vm.form.plateNumber = val.trim()
                              }
                            },
                            model: {
                              value: _vm.form.plateNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "plateNumber", $$v)
                              },
                              expression: "form.plateNumber"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Warehouse.DriverPhone") } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.driverPhone,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "driverPhone", $$v)
                              },
                              expression: "form.driverPhone"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.DriverIDCard") } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.driverIdCard,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "driverIdCard", $$v)
                              },
                              expression: "form.driverIdCard"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_Destination") }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.destination,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "destination", $$v)
                              },
                              expression: "form.destination"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 3, no: "remarks" },
                            model: {
                              value: _vm.form.remarks,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "remarks", $$v)
                              },
                              expression: "form.remarks"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            [
              _vm.isEdit
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        no: "showUseCarApplicationFormTabDialog"
                      },
                      on: { click: _vm.showUseCarApplicationFormTabDialog }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_add")))]
                  )
                : _vm._e(),
              _vm.isEdit
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        no: "removeUseCarApplicationForm"
                      },
                      on: { click: _vm.removeUseCarApplicationForm }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Remove")))]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid-wrapper", {
                staticStyle: { height: "100%" },
                attrs: {
                  "config-module": "202506073",
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.form.useCarApplicationFormVos,
                  "show-selected-color": false,
                  "check-sub-record": false
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            id: "newSuccessDialog",
            visible: _vm.newSuccessDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_VehicleOrderGeneratedSuccess"),
            width: "500px",
            "append-to-body": "",
            "close-on-click-modal": false,
            "show-close": false,
            "custom-class": "app-main-content"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.newSuccessDialog, "visible", $event)
            }
          }
        },
        [
          _c("div", [
            _c("i", {
              staticClass: "el-icon-success",
              staticStyle: { color: "#409EFF", "font-size": "medium" }
            }),
            _c("span", { staticStyle: { "font-size": "medium" } }, [
              _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_VehicleOrderSerialNumber")))
            ]),
            _c(
              "span",
              { staticStyle: { color: "#5f9ae0", "font-size": "medium" } },
              [_vm._v(_vm._s(" " + _vm.form.carFormNo))]
            )
          ]),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "confirm" },
                  on: { click: _vm.toPrint }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Print")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "closeAndCopySerialNumber" },
                  on: { click: _vm.closeAndCopySerialNumber }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("CargoMsg.Cargo_CloseAndCopySerialNumber"))
                  )
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "close" },
                  on: {
                    click: function($event) {
                      _vm.newSuccessDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ]
      ),
      _vm.useCarApplicationFormTabDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                id: "useCarApplicationFormTabDialog",
                visible: _vm.useCarApplicationFormTabDialog.visible,
                title: _vm.$t("CargoMsg.Cargo_VehicleRequestForm"),
                width: "1500px",
                "append-to-body": "",
                "close-on-click-modal": false,
                "show-close": false,
                "custom-class": "app-main-content"
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(
                    _vm.useCarApplicationFormTabDialog,
                    "visible",
                    $event
                  )
                }
              }
            },
            [
              _c("use-car-application-form-tab-list", {
                ref: "useCarApplicationFormTabList",
                attrs: {
                  lob: _vm.lob,
                  "exclude-use-car-application-form-uuids":
                    _vm.useCarApplicationFormTabDialog
                      .excludeUseCarApplicationFormUuids,
                  source: "carFormTabDetail"
                }
              }),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "1" },
                      on: {
                        click: function($event) {
                          return _vm.addUseCarApplicationForm(
                            _vm.$refs.useCarApplicationFormTabList.selectedRows
                          )
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "2" },
                      on: {
                        click: function($event) {
                          _vm.useCarApplicationFormTabDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }